import { MechanicalInformationModal } from '@/modules/MechanicalInformation/ui/MechanicalInformationModal'
import { LogoutModal } from '@/modules/Auth/ui/Logout/LogoutModal'
import { SwitchUserModal } from '@/modules/Auth/ui/SwitchUser/SwitchUserModal'
import { ConfirmDetailsModal } from '@/modules/ConfirmDetails/ui/ConfirmDetailsModal'
import { OfficialReportModal } from '@/modules/OfficialReport'
import { DeleteLog } from './ui/DeleteModal'
import { AddRoute } from '@/pages/Disruptions/ui/components/modals/AddRouteModal'
import { EditLocationModal } from '@/modules/CombinedLogs/ui/components/TableForm/Modals/EditLocationModal'
import { ChangeRunModal } from '@/pages/VehicleAllocationController/ui/AllocationList/Modals/ChangeRunModal'
import { FlagLogUnfinishedModal } from '@/modules/CombinedLogs/ui/components/modals/FlagLogUnfinishedModal'
import { UnlockRecordModal } from '@/modules/CombinedLogs/ui/components/modals/UnlockRecordModal'
import { EndOfShiftModal } from '@/modules/CombinedLogs/ui/components/modals/EndOfShiftModal'
import { ReassignWorkstationRouteModal } from '@/modules/Workstation/ui/modals/ReassignWorkstationRouteModal'
import { RouteDetailsModal } from '@/modules/RouteDetails'
import { MarkAsDoneModal } from '@/pages/Flagged/ui/components/MarkAsDoneModal'
import { EditFlagModal } from '@/pages/Flagged/ui/components/EditFlagModal'

export enum ModalTypes {
    mechanicalInformation = 'mechanicalInformation',
    logout = 'logout',
    switchUser = 'switchUser',
    confirmDetails = 'confirmDetails',
    officialReport = 'officialReport',
    deleteModal = 'deleteModal',
    editLocationModal = 'editLocationModal',
    changeRunModal = 'changeRunModal',
    flagLogUnfinishedModal = 'flagLogUnfinishedModal',
    // removeUnfinishedFlagLogModal = 'removeUnfinishedFlagLogModal',
    unlockRecordModal = 'unlockRecordModal',
    endOfShiftModal = 'endOfShiftModal',
    reassignWorkstationRouteModal = 'reassignWorkstationRouteModal',
    routeDetailsModal = 'routeDetailsModal',
    addRouteModal = 'addRouteModal',
    markAsDoneModal = 'markAsDoneModal',
    editFlagModal = 'editFlagModal',
}
export const modalRegistry: Record<ModalTypes, React.ComponentType<any>> = {
    [ModalTypes.mechanicalInformation]: MechanicalInformationModal,
    [ModalTypes.logout]: LogoutModal,
    [ModalTypes.switchUser]: SwitchUserModal,
    [ModalTypes.confirmDetails]: ConfirmDetailsModal,
    [ModalTypes.officialReport]: OfficialReportModal,
    [ModalTypes.deleteModal]: DeleteLog,
    [ModalTypes.editLocationModal]: EditLocationModal,
    [ModalTypes.changeRunModal]: ChangeRunModal,
    [ModalTypes.flagLogUnfinishedModal]: FlagLogUnfinishedModal,
    // [ModalTypes.removeUnfinishedFlagLogModal]: RemoveUnfinishedFlagLogModal,
    [ModalTypes.unlockRecordModal]: UnlockRecordModal,
    [ModalTypes.endOfShiftModal]: EndOfShiftModal,
    [ModalTypes.reassignWorkstationRouteModal]: ReassignWorkstationRouteModal,
    [ModalTypes.routeDetailsModal]: RouteDetailsModal,
    [ModalTypes.addRouteModal]: AddRoute,
    [ModalTypes.markAsDoneModal]: MarkAsDoneModal,
    [ModalTypes.editFlagModal]: EditFlagModal,
}
